import { defineWebComponent } from "../webcomponents-utils";
import {WlChip} from "./chip.component";

export * from './chip.component';
export default WlChip;

defineWebComponent('wl-chip', WlChip);
